"use client";

import React from "react";
import Link from "next/link";
import { Globe, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { DomainContactCard } from "./DomainContactCard";
import type { DomainContactsProps } from "./types";

export const DomainContacts: React.FC<DomainContactsProps> = ({
  contacts,
  totalContacts,
  domain,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <LoadingSpinner size="md" />
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="flex items-center gap-3 text-muted-foreground py-4">
        <Globe className="h-4 w-4" />
        <span>No other contacts found with {domain} email domain</span>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {contacts.map((contact) => (
        <DomainContactCard key={contact.id} contact={contact} />
      ))}

      {totalContacts > contacts.length && (
        <div className="pt-3 border-t">
          <Link href={`/contacts?search=${domain}`}>
            <Button variant="outline" size="sm" className="w-full flex items-center gap-2">
              View all {totalContacts} contacts with {domain} domain
              <ExternalLink className="h-3 w-3" />
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};
